module.exports = __webpack_public_path__ + "img/4-424-424.1374f4cf.png";